import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { WhatsappUnsubscribeComponent } from './components/whatsapp-unsubscribe/whatsapp-unsubscribe.component';
import { GetClientShippingInfoComponent } from "./get-client-shipping-info/get-client-shipping-info.component";
import { CanLeaveGuard } from './guards/can-leave.guard';
import { DevelopmentGuard } from './guards/development.guard';
import { QueryParamGuard } from './guards/query-param.guard';
import { HomeNewComponent } from "./home-new/home-new.component";


const routes: Routes = [
  {
    path: 'development-login',
    loadChildren: () => import('./development-login/development-login.module').then(m => m.DevelopmentLoginPageModule)
  },
  {
    path: '', canActivate: [DevelopmentGuard], children: [
      {
        path: '',
        component: HomeNewComponent,
        loadChildren: () => import('./home-new/home-new.module').then(m => m.HomeNewModule),
        canDeactivate: [CanLeaveGuard]
      },
      { path: 'auth/login', loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule) },
      { path: 'auth/signup', loadChildren: () => import('./signup/signup.module').then(m => m.SignupPageModule) },
      {
        path: 'auth/forgot-password',
        loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
      },
      {
        path: 'account',
        loadChildren: () => import('./account/account.module').then(m => m.AccountPageModule)
      },
      {
        path: 'order',
        redirectTo: 'account/pedidos',
      },
      {
        path: 'pedidos',
        redirectTo: 'account/pedidos',
      },
      {
        path: 'cart',
        loadChildren: () => import('./cart/cart.module').then(m => m.CartPageModule)
      },
      {
        path: 'payment-result',
        loadChildren: () => import('./payment-result/payment-result.module').then(m => m.PaymentResultPageModule)
      },
      {
        path: 'test',
        loadChildren: () => import('./test/test.module').then(m => m.TestPageModule)
      },
      {
        path: 'wallet',
        redirectTo: 'account/wallet'
      },
      {
        path: 'embajadores',
        redirectTo: 'account/embajadores'
      },
      {
        path: 'out-of-service',
        loadChildren: () => import('./out-of-service/out-of-service.module').then(m => m.OutOfServicePageModule)
      },
      {
        path: 'productos',
        redirectTo: 'papeleria/catalogo'
      },
      {
        path: 'tienda',
        redirectTo: 'papeleria/catalogo'
      },
      {
        path: 'papeleria',
        loadChildren: () => import('./shop/shop.module').then(m => m.ShopPageModule)
      },
      {
        path: 'mantenimiento',
        loadChildren: () => import('./maintenance/maintenance.module').then(m => m.MaintenanceModule)
      },
      {
        path: 'seguimiento-envio',
        component: GetClientShippingInfoComponent,
        loadChildren: () => import('./get-client-shipping-info/get-client-shipping-info.module').then(m => m.GetClientShippingInfoModule),
      },
      {
        path: 'unsubscribe/whatsapp',
        component: WhatsappUnsubscribeComponent,
        canActivate: [QueryParamGuard],
        data: { requiredQueryParam: 'u' }
      },
      {
        path: '**',
        redirectTo: ''
      },
    ]
  }
];

//TODO J.A. revisar bien el ruteo hay cambios en guard, relativeLinkResolution: 'legacy' y trataremos de no hacer un preloading de tododos lo smodulos
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
